import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {CityProps} from '../types';
import citiesKeys from '../util/cities-keys';

export interface CreateCityProps extends Omit<CityProps, 'id'> {}

const useCreateCity = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: CityProps) => create(citiesKeys.list(), data);

  return useApiMutation<CityProps>({
    url: '/cities',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar cidade',
    successTitle: 'Cadastrar cidade',
    successMessage: 'Cidade cadastrada com sucesso',
    redirectUrl: '/settings/cities',
    onSuccess,
  });
};

export default useCreateCity;
